/* BannerSectionRenderer.js */

"use strict";
const ButtonControl = require("@gluenetworks/steve_ui_core").Control.Action.Button;
// const InputCheckboxControl = require("@gluenetworks/steve_ui_core").Control.Boolean.InputCheckbox;

class BannerSectionRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("banner-section-gl");
        this._rootElem.component = this._model;

        this._topHeaderContainer = document.createElement('h1');
        this._topHeaderContainer.innerText = 'Gluware End User License Agreement (“Gluware EULA”)';

        this._contentContainer = document.createElement('content-container');

        this._contentHeaderContainer = document.createElement('content-header-container');
        this._contentHeaderContainer.innerText = 'Gluware';

        this._textContainer = document.createElement('text-container');

        this._buttonContainer = document.createElement('button-container');

        this._acceptButton = new ButtonControl({
            darkTheme: true,
            label: 'Proceed',
            active: true
        });
        this._acceptButton.renderer.rootElement.classList.add('proceed-button');
        this._cancelButton = new ButtonControl({darkTheme: true, label: 'Cancel'});

        this._registerListeners();
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */

    /********************************************/
    _registerListeners() {
        this._cancelButton.on('UserClick', this._onCancelButtonClick = this._onCancelButtonClick.bind(this));
        this._acceptButton.on('UserClick', this._onAcceptButtonClick = this._onAcceptButtonClick.bind(this));
    }

    _unregisterListeners() {
        this._cancelButton.removeListener('UserClick', this._onCancelButtonClick);
        this._acceptButton.removeListener('UserClick', this._onAcceptButtonClick);
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */

    /*******************************************/
    shutdown() {
        this._unregisterListeners();

        return Promise.resolve()
            .then(() => {
                //TODO set all class members to undefined here
                this._model = undefined;
                this._rootElem.remove();
                this._rootElem = undefined;
            })
            .catch(() => {
                //TODO - how do you want to handle an error to shutting down?
            });
    }

    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        return this._model.whenModelIsReady().then((data) => {
            if(!(data && data.text && data.refusalButtonLabel && data.acceptButtonLabel)) {
                this._model._logger.warn("No Banner details, please configure the banner");
                return Promise.resolve();
            }
            if (!this._rootElem.hasChildNodes()) {
                this._rootElem.appendChild(this._contentContainer);
                this._contentContainer.appendChild(this._textContainer);
                this._textContainer.innerHTML = data.text;
                this._contentContainer.appendChild(this._buttonContainer);
                this._cancelButton.setLabel(data.refusalButtonLabel);
                this._buttonContainer.appendChild(this._cancelButton.renderer.rootElement);
                this._acceptButton.setLabel(data.acceptButtonLabel);
                this._buttonContainer.appendChild(this._acceptButton.renderer.rootElement);
            }
        });
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START PRIVATE RENDER METHODS */
    /*******************************************/

    //TODO Private Render Methods here

    /*******************************************/
    /* END PRIVATE RENDER METHODS */
    /* START HANDLER METHODS */

    /*******************************************/

    _onAcceptButtonClick() {
        this._model.updateUserBannerAccept();
    }

    _onCancelButtonClick() {
        this._model.returnToLogin();
    }

    _onAcceptCheckBoxClick(val) {
        this._acceptButton.disabled = !val;
    }

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE API METHODS */
    /*******************************************/
    //TODO - Nobody should be using methods on a Renderer directly so make all these methods private
    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}

module.exports = BannerSectionRenderer;